import React from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { selectCartState } from "@/store/features/cartSlice"

import CustomerSupport from "@/components/Shared/CustomerSupport"

import { addAnalyticsAuthLinks } from "@/components/cart/analytics"

const CartInfo = ({ i18n = {}, supportLine = "" }) => {
  const { isAuth } = useSelector(selectAuthState)
  const { cart: activeCart = {} } = useSelector(selectCartState)
  const dispatch = useDispatch()

  const onClickSignIn = event => {
    if (!isAuth) {
      dispatch(setAuthModalVisibility({ show: true }))
    }
    const linkName = event.target.textContent.toLowerCase()
    addAnalyticsAuthLinks(activeCart, linkName)
  }
  const onClickSignUp = event => {
    dispatch(setAuthModalVisibility({ show: true, active: 1 }))
    const linkName = event.target.textContent.toLowerCase()
    addAnalyticsAuthLinks(activeCart, linkName)
  }

  return (
    <div className="cart-info">
      {!isAuth && (
        <p className="cart-info__desc">
          <span
            className="gbh-data-layer"
            tabIndex="0"
            role="link"
            onClick={e => onClickSignIn(e)}
          >
            {`${i18n.signIn} `}
          </span>
          {`${i18n.or} `}
          <span
            className="gbh-data-layer"
            tabIndex="0"
            role="link"
            onClick={e => onClickSignUp(e)}
          >
            {i18n.createCartAccount}
          </span>
          {` ${i18n.saveYourCart}`}
        </p>
      )}
      <CustomerSupport supportInfo={supportLine} name="cart" />
    </div>
  )
}

export default CartInfo
